
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TouchFullScreen extends Vue {
  @Prop() readonly handleDs!: Function;
}
